// extracted by mini-css-extract-plugin
export default {"table":"V2rec","tr":"tG2Ve","td":"_Kdrt","row":"bjbdv","rowTitle":"bsDA8","rowDescription":"FsSu6","cellTitle":"BsRW5","cellDescription":"qkh1i"};